import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function ContactForm({ variant = "desktop" }) {
  const [formData, setFormData] = useState({ name: "", phone: "", email: "" });
  const navigate = useNavigate();

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value)) {
      setFormData({ ...formData, name: value });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone, email } = formData;

    if (!/^[A-Za-z\s]+$/.test(name)) {
      toast.error("Please enter a valid name (letters only).");
      return;
    }
    if (phone.length < 10) {
      toast.error("Please enter a valid phone number.");
      return;
    }
    if (!email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      const res = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, phone, email }),
      });

      const statusCode = res.status;
      const textResponse = await res.text();

      if (statusCode === 200) {
        toast.success(textResponse || "Form submitted successfully!");
        setTimeout(() => {
          navigate("/thank-you");
        }, 1500);
      } else {
        toast.error(textResponse || "Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Error submitting form. Please try again.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`${
        variant === "desktop"
          ? "flex items-center justify-between gap-10 font-inter"
          : "space-y-6 text-[#000000d9] font-inter text-[15px]"
      }`}
    >
      {/* Name */}
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleNameChange}
        placeholder="Your Name"
        className={
          variant === "desktop"
            ? "flex-1 border font-inter bg-[#f6f4ed] border-white text-black px-3 py-1 focus:outline-none placeholder-black rounded-md"
            : "w-full bg-transparent border-b-2 border-[#c55b12] outline-none"
        }
        required
      />

      {/* Phone */}
      <PhoneInput
        country={"in"}
        value={formData.phone}
        name="phone"
        onChange={(value) => setFormData({ ...formData, phone: value })}
        enableSearch
        containerStyle={variant === "desktop" ? { flex: 1 } : {}}
        inputStyle={
          variant === "desktop"
            ? {
                width: "100%",
                border: "1px solid white",
                fontSize: "15px",
                color: "#000",
              }
            : {
                width: "100%",
                border: "none",
                borderBottom: "2px solid #c55b12",
                borderRadius: 0,
                backgroundColor: "transparent",
                outline: "none",
                boxShadow: "none",
              }
        }
        buttonStyle={
          variant === "desktop"
            ? { border: "none", backgroundColor: "#f6f4ed" }
            : { border: "none", backgroundColor: "transparent", borderRadius: 0 }
        }
        required
          dropdownClass="custom-phone-dropdown" 
      />

      {/* Email */}
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email"
        className={
          variant === "desktop"
            ? "flex-1 bg-[#f6f4ed] border font-inter border-white text-black px-3 py-1 focus:outline-none placeholder-black rounded-md"
            : "w-full bg-transparent border-b-2 border-[#c55b12] outline-none"
        }
        required
      />

      {/* Submit Button */}
      <button
        type="submit"
        className={
          variant === "desktop"
            ? "bg-[#f6f4ed] text-[#c55b12] px-3 py-1 hover:bg-[#f3f3f3] transition-all duration-200 shadow-md whitespace-nowrap rounded-md font-semibold tracking-wider"
            : "px-6 py-3 bg-[#c55b12] text-white rounded-2xl transition-shadow duration-300 font-inter w-[40%]"
        }
      >
        Download Brochure
      </button>
    </form>
  );
}
